import { EditorSyncFiles } from "../EditorSync";
import { CueSheetItem } from "../types/editor";
import EditorPlayerBlackout from "./EditorPlayerBlackout";
import EditorPlayerImage from "./EditorPlayerImage";
import EditorPlayerSet from "./EditorPlayerSet";
import EditorPlayerVideo from "./EditorPlayerVideo";

export const EditorPlayerBuffer = ({
  item,
  files,
}: {
  item: CueSheetItem;
  files: EditorSyncFiles;
}) => {
  switch (item.type) {
    case "image":
      return <EditorPlayerImage files={files} src={item.set?.still || ""} />;

    case "video":
      return (
        <EditorPlayerVideo
          src={item.set?.loop || item.set?.action || ""}
          loop={item.set?.loop ? true : false}
          playing={true}
          paused={false}
          muted={true}
          files={files}
        />
      );

    case "set":
      return <EditorPlayerSet item={item} files={files} />;

    default:
      return <EditorPlayerBlackout />;
  }
};

export default EditorPlayerBuffer;
